import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'cookie_consent';

// Module-scoped (not defined inside the component) so its identity is stable
// across renders and it can be safely omitted from the mount-only effect's
// dependency array below.
function grantConsent() {
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', { analytics_storage: 'granted' });
  }
}

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === 'accepted') {
      grantConsent();
    } else if (!stored) {
      setVisible(true);
    }
  }, []);

  function accept() {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    grantConsent();
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6">
      <div className="mx-auto max-w-3xl rounded-xl bg-white shadow-lg ring-1 ring-black/5 p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-text-light flex-1">
          We use cookies to understand how visitors interact with our site.
          No personal data is sold or shared with third parties. See our{' '}
          <Link to="/privacy" className="text-sage-dark underline hover:text-sage">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            type="button"
            onClick={decline}
            className="rounded-lg px-4 py-2 text-sm font-medium text-text-light hover:bg-gray-100 transition-colors cursor-pointer"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={accept}
            className="rounded-lg px-4 py-2 text-sm font-medium text-white bg-sage hover:bg-sage-dark transition-colors cursor-pointer"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
